import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import AssetLoader from './_load/AssetLoader'
import { TabsContext } from '../../../packages/kiti/components/tabs/TabsContext'
import { HorizontalLine } from '../../../components/shapes/Line'
import TabsContent from '../../../packages/kiti/components/tabs/TabsContent'
import { COLORS } from '@btime/constants'
import Qrcodes from './tabs/Qrcodes'
import Details from './tabs/Details'
import { useSessionPermission } from '@btime/react-session'

const ShowAssetModal = props => {
  const shouldShowQRCodeTab = useSessionPermission('showQRCodeOnModalDetails')

  const tabsOptions = [
    { name: 'Detalhes', render: () => <Details /> },
    { name: 'QR Codes', render: () => <Qrcodes />, notShow: !shouldShowQRCodeTab }
  ]

  return (
    <ControlledModal width="48rem" {...props}>
      <AssetLoader>
        <Grid justify="space-between" align="flex-start" paddingGutter={0.5}>
          <Col flex={2}>
            <Separator weight={6} />

            <TabsContext options={tabsOptions}>
              <ModalHeader />

              <HorizontalLine thin lineColor={COLORS.light2} />
              <Separator weight={4} />

              <TabsContent />
            </TabsContext>
          </Col>
        </Grid>
      </AssetLoader>
    </ControlledModal>
  )
}

export default ShowAssetModal
